import SlimSelect from 'slim-select';
import {getHash, setHash} from '../Utility/HashUtility';
import {scrollToElement} from '../Utility/ScrollUtility';

export class ProductDetailController {
  private readonly variantSelectRef: HTMLElement | null = document.querySelector('.js-variants-select');
  private readonly variantSelectItems: NodeListOf<Element> = document.querySelectorAll('.js-variants-select-item');
  private readonly summaryRefs = document.querySelectorAll('.js-summary');
  private readonly chartRefs = document.querySelectorAll('.js-rangeChart');
  private readonly drawingsRefs = document.querySelectorAll('.js-drawing');
  private readonly optionsRefs = document.querySelectorAll('.js-option');
  private readonly valuesRefs = document.querySelectorAll('.js-values');
  private readonly valuesTabRefs: HTMLElement | null = document.querySelector('.js-valuesTab');
  private readonly rangeChartTabRefs: HTMLElement | null = document.querySelector('.js-rangeChartTab');
  private readonly drawingsTabRefs: HTMLElement | null = document.querySelector('.js-drawingsTab');
  private readonly optionsTabRefs: HTMLElement | null = document.querySelector('.js-optionsTab');
  private readonly combinationsTabRefs: HTMLElement | null = document.querySelector('.js-combinationsTab');
  private readonly downloadsTabRefs: HTMLElement | null = document.querySelector('.js-downloadsTab');
  private readonly supportTabRefs: HTMLElement | null = document.querySelector('.js-supportTab');
  private readonly goToDownloadButtonRef = document.querySelector('.js-goToDownloads');
  private readonly downloadTabButtonRef: HTMLButtonElement | null = document.querySelector('.js-tabsButtonDownloads');
  private readonly summaryActiveClass = 'summary__info--active';
  private readonly chartActiveClass = 'rangeCharts__chart--active';
  private readonly valuesActiveClass = 'values--active';
  private readonly optionActiveClass = 'option--active';
  private variantSelect: SlimSelect | null = null;

  constructor() {
    this.initSelect();
    if (this.goToDownloadButtonRef) {
      this.goToDownloadButtonRef.addEventListener('click', () => {
        if (this.downloadTabButtonRef) {
          this.downloadTabButtonRef.click();
          scrollToElement(this.downloadTabButtonRef);
        }
      });
    }
  }

  hideNodeListOfElementsButShowNodeListOfElement(refsToHide: NodeListOf<Element>, refsToShow: NodeListOf<Element>) {
    for (let i = 0; i < refsToHide.length; i++) {
      if (!refsToHide[i].classList.contains('hide')) {
        refsToHide[i].classList.add('hide');
      }
    }
    for (let i = 0; i < refsToShow.length; i++) {
      refsToShow[i].classList.remove('hide');
    }
  }

  initSelect() {
    if (this.variantSelectRef) {
      let selectedDrawings: NodeListOf<Element>;
      let variantsData: { innerHTML: string, text: string, value: string }[] = [];
      this.variantSelectItems?.forEach((item: HTMLElement) => {
        variantsData.push({innerHTML: item.innerHTML, text: '', value: item.dataset.value!});
      });

      this.variantSelect = new SlimSelect({
        select: this.variantSelectRef,
        showSearch: false,
        data: variantsData,
      });

      this.variantSelectRef.addEventListener('change', () => {
        if (this.summaryRefs) {
          for (let i = 0; i < this.summaryRefs.length; i++) {
            this.summaryRefs[i].classList.remove(this.summaryActiveClass);
          }
        }
        if (this.chartRefs) {
          for (let i = 0; i < this.chartRefs.length; i++) {
            this.chartRefs[i].classList.remove(this.chartActiveClass);
          }
        }
        if (this.valuesRefs) {
          for (let i = 0; i < this.valuesRefs.length; i++) {
            this.valuesRefs[i].classList.remove(this.valuesActiveClass);
          }
        }
        if (this.variantSelect) {
          const selected = this.variantSelect.selected().toString();
          setHash(selected);
          document.querySelector('.js-summary-' + selected)?.classList.add(this.summaryActiveClass);
          const selectedCharts = document.querySelector('.js-rangeChart-' + selected);
          this.handleTabVisibility();
          selectedCharts?.classList.add(this.chartActiveClass);

          this.hideNodeListOfElementsButShowNodeListOfElement(this.drawingsRefs, document.querySelectorAll('.js-drawing-' + selected));

          const selectedValues = document.querySelectorAll('.js-values-' + selected);
          for (let i = 0; i < selectedValues.length; i++) {
            selectedValues[i].classList.add(this.valuesActiveClass);
          }

          this.hideNodeListOfElementsButShowNodeListOfElement(this.optionsRefs, document.querySelectorAll('.js-option-' + selected));
        }
      });

      const initialHash = getHash();
      if (initialHash) {
        if (this.variantSelect && this.variantSelectRef.querySelector('option[value="' + initialHash + '"]')) {
          this.variantSelect.set(initialHash);
        }
      } else {
        const selected = this.variantSelect.selected().toString();
        document.querySelector('.js-summary-' + selected)?.classList.add(this.summaryActiveClass);
      }
      const initSelected = this.variantSelect.selected().toString();
      const initSelectedCharts = document.querySelector('.js-rangeChart-' + initSelected);
      if (this.rangeChartTabRefs) {
        if (!initSelectedCharts?.querySelector('.js-rangeChartImg')) {
          this.rangeChartTabRefs.classList.add('hide');
        } else {
          this.rangeChartTabRefs.classList.remove('hide');
        }
      }
      initSelectedCharts?.classList.add(this.chartActiveClass);

      this.hideNodeListOfElementsButShowNodeListOfElement(this.drawingsRefs, document.querySelectorAll('.js-drawing-' + initSelected));
      this.hideNodeListOfElementsButShowNodeListOfElement(this.optionsRefs, document.querySelectorAll('.js-option-' + initSelected));


      const initSelectedValues = document.querySelectorAll('.js-values-' + initSelected);
      for (let i = 0; i < initSelectedValues.length; i++) {
        initSelectedValues[i].classList.add(this.valuesActiveClass);
      }
      this.handleTabVisibility();
      const firstTabRef: HTMLButtonElement | null = document.querySelector('.productDetailLower .js-tabsElement:not(.hide) .js-tabsButton');
      if (firstTabRef) {
        firstTabRef.click();
      }
    }
  }

  handleTabVisibility() {
    this.hideTabIfNeeded(this.valuesTabRefs, 'js-values');
    this.hideTabIfNeeded(this.rangeChartTabRefs, 'js-rangeChart .rangeCharts__chartImage');
    this.hideTabIfNeeded(this.drawingsTabRefs, 'drawings__drawing');
    this.hideTabIfNeeded(this.combinationsTabRefs, 'combinations');
    this.hideTabIfNeeded(this.downloadsTabRefs, 'js-download');
    this.hideTabIfNeeded(this.optionsTabRefs, 'options__option');
    this.hideTabIfNeeded(this.supportTabRefs, 'js-support');
  }

  hideTabIfNeeded(tabRef: HTMLElement | null, classToCheckFor: string) {
    if (tabRef) {
      if (!document.querySelector('.' + classToCheckFor)) {
        tabRef.classList.add('hide');
      } else {
        tabRef.classList.remove('hide');
      }
    }
  }
}
